
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, Prop, Vue } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";

@Component({
  components: {}
})
export default class AtsDetailTable extends Vue {
  @Prop({ default: [], type: Array }) tableData!: [];
  created() {
    //
  }
  mounted() {
    //
  }
  edit(scope: any) {
    this.$emit("edit", scope.row);
  }
}
